import React from 'react'
import PlacedSvg from "../../assets/icons/Placed.svg"

const Placed = () => {
  return (
    <img src={PlacedSvg} alt='Placed'/>
  )
}

export default Placed;